<template>
    <qd-admin-auth pid="41">
        <div class="corpinfo">
            <div v-if="isEdit">
                <edit-related v-if="!isMainCorp" :industrylist="industry_list" :corp-admin="corp_admin" :edit-info="info" @goBack="goBack" />
                <edit-main v-else :industrylist="industry_list" :corp-admin="corp_admin" :edit-info="info" @goBack="goBack" />
            </div>
            <list v-else :industrylist="industryObj" :corp-admin="corp_admin" :combos-info="combosInfo" @edit="edit" />
        </div>
    </qd-admin-auth>
</template>
<script>
import { isPrivate } from 'src/config/private';
import editRelated from './pages/edit-related.vue';
import list from './pages/list.vue';
import editMain from './pages/edit-main.vue';
export default {
    components: {
        editRelated,
        list,
        editMain,
    },
    data() {
        return {
            corp_admin: {
                // 是否需要审核
                need_verify: true,
                // 是否需要上传附件送审
                need_attachment: true,
                // 是否需要验证手机号 和 手机验证码
                need_sms_code: true,
                // 是否需要关联企业
                need_related_corp: true,
            },
            industry_list: [],
            industryObj: {},
            combosInfo: {},
            isEdit: false,
            info: {},
            isMainCorp: false,
        };
    },
    async created() {
        if (isPrivate) {
            // 私有化环境判断展示隐藏
            await this.getPrivateCorpFlag();
        }
        // 获取套餐信息
        this.getCombos();
        // 获取行业信息
        this.getAccountIndustry();
    },
    methods: {
        goBack() {
            this.isEdit = false;
        },
        edit(data) {
            this.isEdit = true;
            this.info = data.info;
            this.isMainCorp = data.type === 1;
        },
        getPrivateCorpFlag() {
            this.$ajax.post('/mng/account/corpInfo/getPrivateCorpFlag').then((res) => {
                const { data } = res;
                this.corp_admin = data.corp_admin || this.corp_admin;
            });
        },
        getCombos() {
            this.$ajax.get('/mng/account/index/extCorpInfo').then((res) => {
                const { data } = res;
                this.combosInfo = data || this.combosInfo;
            });
        },
        getAccountIndustry() {
            this.$ajax.gatewayGet('/v1/basic/corp/corp/industryInfo').then((res) => {
                const { data } = res;
                const industryList = data.industry_all || [];
                this.industryObj = industryList;
                this.parseData(industryList);
            });
        },
        parseData(data) {
            const industry = [];
            industry.push({
                text: '全部分类',
                value: -3,
                children: [{
                    text: '全部分类',
                    value: -2,
                }],
            });
            for (let i = 0; i < Object.values(data).length; i++) {
                const item = Object.values(data)[i];
                if (item.display === '1') {
                    const cur = {
                        value: Number(item.id),
                        text: item.name,
                        children: [],
                    };
                    if (item.sub) {
                        const sub = cur.children;
                        for (let j = 0; j < Object.values(item.sub).length; j++) {
                            const subItem = Object.values(item.sub)[j];
                            if (subItem.display === '1') {
                                sub.push({
                                    value: Number(subItem.id),
                                    text: subItem.name,
                                });
                            }
                        }
                    }
                    cur.children.unshift({
                        text: '全部分类',
                        value: -2,
                    });
                    industry.push(cur);
                }
            }
            this.industry_list = industry;
        },
    },
};
</script>
<style lang="less" scoped>
.qidian-admin-auth {
    height: calc(100vh - 120px);
}
</style>
